import { ShieldCheck } from 'lucide-react';

const SIGNAL_LABEL = { website: 'website', google_business: 'Google Business Profile', directory_listing: 'directory listings', social_media: 'social media', reviews: 'reviews' };
const FIELD_LABEL = { registered_address: 'address', postcode: 'postcode', sector: 'sector', trading_status: 'trading status', primary_business: 'primary business' };

// Shown on public profiles where the verified owner has confirmed, corrected or disconnected data.
export function OwnerVerdictBadge({ verdict, size = 'md' }) {
  if (!verdict?.active) return null;
  const parts = [];
  if (verdict.confirmed_signals?.length) parts.push(`confirmed ${verdict.confirmed_signals.map(k => SIGNAL_LABEL[k] || k).join(', ')}`);
  if (verdict.disconnected_signals?.length) parts.push(`disconnected mismatched ${verdict.disconnected_signals.map(k => SIGNAL_LABEL[k] || k).join(', ')}`);
  if (verdict.corrected_fields?.length) parts.push(`corrected ${verdict.corrected_fields.map(k => FIELD_LABEL[k] || k).join(', ')}`);
  const when = verdict.updated_at ? new Date(verdict.updated_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : null;
  const title = `The verified owner ${parts.join('; ')}${when ? ` (last updated ${when})` : ''}. Owner-declared data is the most credible source on this profile.`;
  const pad = size === 'md' ? 'px-3 py-1 text-xs' : 'px-2 py-0.5 text-[11px]';
  return (
    <span title={title} data-testid="owner-verdict-badge" className={`inline-flex items-center gap-1 rounded-full font-body font-semibold border cursor-help ${pad}`}
      style={{ color: '#7C2D12', background: '#FFF7ED', borderColor: '#FDBA74' }}>
      <ShieldCheck className="w-3 h-3" strokeWidth={2.5} /> Owner-verified data
    </span>
  );
}

export function OwnerVerdictNote({ verdict }) {
  if (!verdict?.active) return null;
  const n = (verdict.confirmed_signals?.length || 0) + (verdict.disconnected_signals?.length || 0) + (verdict.corrected_fields?.length || 0);
  return (
    <p className="font-body text-xs text-ink-2 flex items-start gap-1.5" data-testid="owner-verdict-note">
      <ShieldCheck className="w-3.5 h-3.5 text-[#C2410C] shrink-0 mt-0.5" />
      <span>The verified owner has reviewed this profile and made {n} update{n === 1 ? '' : 's'}
        {verdict.disconnected_signals?.length ? ` — including removing ${verdict.disconnected_signals.length} scan result${verdict.disconnected_signals.length === 1 ? '' : 's'} that did not belong to this business` : ''}. Owner-declared data overrides automated scan results here.</span>
    </p>
  );
}
